{
  "title": "Draconic Transformation (UA)",
  "source": "Unearthed Arcana 78 - Draconic Options",
  "levelAndSchool": "7th-level transmutation",
  "level": 7,
  "castingTime": "1 bonus action",
  "range": "Self",
  "components": "V, S, M (a statuette of a dragon,",
  "duration": "worth at least 500 gp)",
  "description": [
    "Duration: Concentration, up to 1 minute",
    "With a roar, you draw on the magic of dragons to transform yourself, taking on various draconic features. You gain the following benefits until the spell ends:",
    "You have blindsight with a range of 30 feet. Within that range, you can effectively see anything that isn’t behind total cover, even if you’re blinded or in darkness. Moreover, you can see an invisible creature, unless the creature successfully hides from you.",
    "Incorporeal wings sprout from your back, giving you a flying speed of 40 feet.",
    "When you cast this spell, and as a bonus action on subsequent turns for the duration, you can exhale a breath of shimmering energy in a 30-foot cone. Each creature in the area must make a Dexterity saving throw, taking 3d8 force damage on a failed save or half as much damage on a successful one."
  ],
  "spellLists": ["druid", "sorcerer", "wizard"]
}
